import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWallet1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM4 6V7H20V6H4ZM20 9H4V10H10V12H14V10H20V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet1;
